<template>
  <div>
    <header-vue />
    <section-vue />
  </div>
</template>

<script>
import HeaderVue from "./Header";
import SectionVue from "./Section";
import { authMixin } from "../../mixins/authMixin";

export default {
  mixins: [authMixin],
  components: {
    HeaderVue,
    SectionVue
  }
};
</script>
